import React, { Fragment, useEffect, useRef } from 'react';
import {
  BookingCards, GoalGoal, MatchResult, NextGoal, OverUnder, Period, Scores, Time,
} from './index';
import {
  getHalfTimeOddsMatchResult,
  get_full_time_goals,
  get_half_time_goals,
  get_red_cards
} from '../functions';

const is_dangerous_attack = (st) => st === '11008' || st === '21008';
const isGoalFlash = (g) => Number(g?.goalFlashUntil ?? 0) > Date.now();

function Odds({ game, minutes, total_goals, goals = [0, 0] }) {
  if (Number.isFinite(minutes) && minutes < 0) {
    const min = Math.abs(minutes);
    return <td className="text-center" colSpan={11}>{`starting in ${min} minute${min > 1 ? 's' : ''}`}</td>;
  }

  if (isGoalFlash(game)) {
    const home = game?.t1?.n ?? "Home";
    const away = game?.t2?.n ?? "Away";
    const score = Array.isArray(game?.sc?.GOAL) ? `${game.sc.GOAL[0]}-${game.sc.GOAL[1]}` : (game.score || "");
    return (
      <td className="goalCss" colSpan={11}>
        {home} vs {away} — {score}
      </td>
    );
  }
  

  if (is_dangerous_attack(game?.st)) {
    return <td className="dangerCss" colSpan={11}>{game?.stn}</td>;
  }

  if (!Array.isArray(game?.bt) || game.bt.length === 0) {
    return <td className="text-center" colSpan={11}>No markets</td>;
  }

  return (
    <Fragment>
      <MatchResult blocked={game?.b} odds={game.bt} />
      <OverUnder blocked={game?.b} odds={game.bt} />
      <GoalGoal blocked={game?.b} odds={game.bt} goals={goals} period={game.p} />
      <NextGoal blocked={game?.b} odds={game.bt} totalGoals={total_goals} />
    </Fragment>
  );
}

function GridRow({ event }) {
  const trRef = useRef(null);
  const lastFlashRef = useRef(0);

  const game = event?.obj?.[0];

  useEffect(() => {
    const until = Number(game?.goalFlashUntil ?? 0);
    if (!until) return;

    if (until !== lastFlashRef.current && until > Date.now()) {
      lastFlashRef.current = until;
      trRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [game?.goalFlashUntil]);

  if (!game) return null;

  const bt = Array.isArray(game.bt) ? game.bt : [];
  const ht = getHalfTimeOddsMatchResult(bt) || [];
  const totalHalfTimeOdds = Array.isArray(ht) ? ht.length : 0;

  const sc = game.sc || {};
  const goalPair = Array.isArray(sc.GOAL) ? sc.GOAL : [Number(game.hs ?? 0), Number(game.as ?? 0)];

  const rc = get_red_cards(sc);
  const [t1_red, t2_red] = Array.isArray(rc) ? rc : [0, 0];

  const h1_goals = get_half_time_goals(sc) || [0, 0];
  const ft_goals = get_full_time_goals(sc) || [goalPair[0], goalPair[1]];

  const sec =
    typeof game.seconds === 'string' ? Number(String(game.seconds).split(':')[0]) * 60 + Number(String(game.seconds).split(':')[1])
    : Number.isFinite(game.seconds) ? game.seconds
    : Number.isFinite(game.tm) ? game.tm
    : 0;

  const minutes = sec > 0 ? Math.floor(sec / 60) : 0;

  return (
    <tr ref={trRef} data-match-time={game.tss} >
      <td>{game.cd}</td>
      <td><Period period={game.p} /></td>
      <td><Time period={game.p} minutes={minutes} /></td>
      <td>
        <span>{game?.t1?.n} <BookingCards cardType="RED_CARD" totalCards={t1_red} /></span><br />
        <span>{game?.t2?.n} <BookingCards cardType="RED_CARD" totalCards={t2_red} /></span>
      </td>
      <td className="text-center">
        <Scores goal={ft_goals} h1={h1_goals} hasHalfTimeOdds={totalHalfTimeOdds > 0} minutes={minutes} period={game.p} />
      </td>
      <Odds game={game} minutes={minutes} total_goals={(goalPair[0] ?? 0) + (goalPair[1] ?? 0)} goals={goalPair} />
    </tr>
  );
}

export default GridRow;
